import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { Col, Row, } from 'react-bootstrap';
import { FaEnvelope, } from 'react-icons/fa6';
import Divider from './divider';

export default function LandpageFooter() {
  return (
    <>
      <Divider color="default" className="mt-5 mb-5" />
      <Col xs={12} className="text-center mt-3 mb-3">
        <Link href="/">
          <Image src="/assets/images/logo.png" width="400" height="89" border="0" alt="Logomarca da AboutCar" className="img-fluid" quality={75} />
        </Link>
      </Col>
      <Col xs={12} className="text-center">
        <footer>
          <div>
            <Col xs={12} className="lead">
              <Row>
                <Col>
                  <FaEnvelope className="me-1" />
                  <a href="mailto:contato@aboutcar.com.br">contato@aboutcar.com.br</a>
                </Col>
              </Row>
            </Col>
            <Divider color="default" />
            <Row>
              <Col className="lead">
                &copy;
                {` ${new Date().getFullYear()} AboutCar - Todos os direitos reservados - `}
                <strong>CNPJ: 42.636.052/0001-07</strong>
              </Col>
            </Row>
          </div>
        </footer>
      </Col>
    </>
  );
}
